module.exports = __webpack_public_path__ + "img/2ba6e30.png";